if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      // if (!opener.hasAttribute("data-product-url")){
      //   super.show(opener);
      //   return;
      // };

      const modalOpener = opener.closest('.quick-add');
      if (modalOpener) modalOpener.classList.add('quick-add--visible');
      opener.classList.add('btn--loading');
      opener.setAttribute('aria-disabled', true);
      opener.setAttribute('disabled', true);

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const quickBuyContent = responseHTML.getElementById("quick-buy-content").content;
          Array.from(quickBuyContent.querySelectorAll("noscript")).forEach((noScript) => noScript.remove());
          this.modalContent.replaceChildren(quickBuyContent);
          // opener.removeAttribute('data-product-url');

          const imgsElm = this.modalContent.querySelectorAll('img');

          if(opener.getAttribute('data-product-type') === "Deck") {
            const griptapeOptionsSection = responseHTML.querySelector('section.griptape-options');
            griptapeOptionsSection.childNodes.forEach(item=>{
              this.modalContent.querySelector('#griptape-options').appendChild(item);
            });
            this.modalContent.querySelector('#griptape-options').classList.add('product-form__controls-group');

            var gripNone = this.modalContent.querySelector('#grip_none');
            var gripNoneRadio = this.modalContent.querySelector('#grip_none_radio');
            var griptapeRadios = this.modalContent.querySelectorAll('input[name="items[1]id"]');
            gripInit(gripNone, gripNoneRadio, griptapeRadios);
            
            var applyNone = this.modalContent.querySelector('#apply_none');
            var applyNoneRadio = this.modalContent.querySelector('#apply_none_radio');
            var applyRadios = this.modalContent.querySelectorAll('input[name="items[2]id"]');
            applyInit(applyNone, applyNoneRadio, applyRadios);
          }

          imgsElm.forEach((imgElm) => {
            imgElm.onload = () => {
              imgElm.classList.add('loaded');
            }
          });

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          setTimeout(() => {
            super.show(opener);
          });
        })
        .finally(() => {
          if (modalOpener) modalOpener.classList.remove('quick-add--visible');
          opener.removeAttribute('aria-disabled');
          opener.removeAttribute('disabled');
          opener.classList.remove('btn--loading');
        });
    }
  });
}
